import React from 'react';
import { ServiceCheckPayload } from "types/index";

import ListItem from './ListItem';

import classes from './style.module.scss';

export interface ListProps {
    list: ServiceCheckPayload[]
    onSelect: (item: any, status: ServiceCheckPayload['status']) => void
    onRegisterIssue: (item: ServiceCheckPayload) => void
    isWorkOrderChecklist?: boolean
}

export type ListComponent = React.FC<ListProps>

const List: ListComponent = ({ list, onSelect, onRegisterIssue, isWorkOrderChecklist = false }) => (
    <div className={classes['list']}>
        {list.map((item, index) => <ListItem key={index} item={item} onSelect={onSelect} onRegisterIssue={onRegisterIssue} isWorkOrderChecklist={isWorkOrderChecklist} />)}
    </div>
);

export default List
